import * as React from 'react';
import { useEffect } from 'react';
import { Header, SpaceBetween } from '@amzn/awsui-components-react-v3/polaris';
import { ManageDatasets } from './index';
import { TABLE_CONTENT_TYPE } from 'src/commons/constants';
import { CommonPageProps } from 'src/components/common/CommonPageProps';

export interface PublishTablesComponentProps extends CommonPageProps {
  toggleHelp(): void;
  title: string;
}

const PublishTablesComponent = (props: PublishTablesComponentProps) => {
  useEffect(() => {
    props.setContentType(TABLE_CONTENT_TYPE);
  }, []);

  return (
    <SpaceBetween size='xl'>
      <Header variant='h1' description={'Easily ingest your S3, or DynamoDB data to a data lake with Tethys.'}>
        Tethys
      </Header>
      <ManageDatasets {...props} />
    </SpaceBetween>
  );
};

export default PublishTablesComponent;
